import React from "react";
import MUITextField from "@mui/material/TextField";
function TextField({ type = "text", size = "medium", variant = "outlined", color = "primary", ...props }) {
    return (React.createElement(MUITextField, { ...props, type: type, variant: variant, size: size, color: color }));
}
export default TextField;
//# sourceMappingURL=TextField.js.map